<!-- Category Section Start -->
<section class="category-section-2">
    <!-- <div class="container-fluid-lg loader" *ngIf="isLoading">

    </div> -->
    <div class="container-fluid-lg">
        <div class="title">
            <h2>Shop By Categories</h2>
        </div>
        <div class="row " *ngIf="isLoading">
            <div class="col-12 d-flex justify-content-center ">
                <div class="spinner-border text-success " role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!isLoading && DataList.length; else emptyData">
            <div class="col-12">
                <div class="category-slider arrow-slider">
                    <div *ngFor="let Data of DataList">
                        <div class="shop-category-box border-0 wow fadeIn">
                            <a (click)="navigateToShopDetail(Data.id, '0',Data?.category_slug)" class=" circle-1 ">
                                <img [src]="imageBaseUrl + Data?.category_image" class="img-fluid blur-up lazyload" alt />
                            </a>
                            <div class="category-name ">
                                <h6>{{ Data.category_name }}</h6>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 d-flex justify-content-center">
                <a (click)="navigateToCatSubList('subcat-cat_slug_en' )" class="btn btn-md text-white theme-bg-color mt-4 mx-auto">View All</a>
            </div>
        </div>

    </div>
    <ng-template #emptyData>
        <!-- <div class="container-fluid-lg" > -->

        <div class="row" *ngIf="!isLoading">
            <div class="col-12 d-flex justify-content-center">
                <div class="svr_nodata">
                    <h4>No data available!</h4>
                    <p>There is no data to show you right now</p>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </ng-template>
</section>
<!-- Category Section End -->